exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1gN8uXOfybjSaC{text-align:center;margin-bottom:12px}._9_-qCCbjiiNeHt{margin-bottom:0}._17ubmepy2-mYZb{flex:1 1 auto;overflow-y:auto;overflow-x:hidden;z-index:1;min-height:0}._1NBxMapN6ogWWX{display:flex}._13EPD62dgXxJoa{width:100%;margin-bottom:8px;min-height:72px}._1vnFiqTFvUbHmO,._2t77MEi0PcsMTi{margin-top:8px;margin-bottom:0}.qc5qf-WU-D6S1U{text-decoration:none}.o0k1FA-_28rf9K{display:flex;flex-direction:column;margin-left:8px}.o0k1FA-_28rf9K ._3Piz0dNsYmYOhL{width:32px;padding:6px 8px;margin-bottom:8px}", ""]);

// exports
exports.locals = {
	"emptyStateMessage": "_1gN8uXOfybjSaC",
	"createNewTemplateButton": "_9_-qCCbjiiNeHt",
	"templateCards": "_17ubmepy2-mYZb",
	"templateCardContainer": "_1NBxMapN6ogWWX",
	"templateCard": "_13EPD62dgXxJoa",
	"editTemplatesButton": "_1vnFiqTFvUbHmO",
	"finishEditingButton": "_2t77MEi0PcsMTi",
	"noTextDecoration": "qc5qf-WU-D6S1U",
	"controlButtons": "o0k1FA-_28rf9K",
	"controlButton": "_3Piz0dNsYmYOhL"
};